import { configureStore } from '@reduxjs/toolkit';
import diwaliReducer from "./pages/diwaliEscapeRoom/diwaliSlice";

export const store = configureStore({
  reducer: {
    diwali: diwaliReducer
  }
});
